import { Card, CardBody, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EspdResponseDataType, type EspdResponseDto, type ResolvedEspdCriterionDto } from "../../../../../autogen/bff-api";
import { EspdRequirementGroupView } from "./EspdRequirementGroupView";
import { espdAnswerFor } from "./useEspdAnswers";

interface Props {
  criterion: ResolvedEspdCriterionDto;
  espd: EspdResponseDto;
  onChange: (next: EspdResponseDto) => void;
  readOnly: boolean;
}

export const EspdCriterionForm = ({ criterion, espd, onChange, readOnly }: Props) => {
  const { i18n } = useTranslation();
  const norsk = i18n.language.startsWith("no");
  const name = (norsk && criterion.nameNorwegian) || criterion.name;
  const description = (norsk && criterion.descriptionNorwegian) || criterion.description;
  const firstGroupLead = criterion.requirementGroups[0]?.requirements.find(
    (r) => r.responseDataType === EspdResponseDataType.Indicator,
  );
  const mainAnswerProvided = firstGroupLead ? espdAnswerFor(espd, firstGroupLead.id)?.indicator !== undefined : true;

  return (
    <Card variant="outline" rounded="xl">
      <CardBody>
        <Heading size="sm" mb="1">
          {name}
        </Heading>
        {description && (
          <Text fontSize="sm" color="smMuted" mb="4">
            {description}
          </Text>
        )}
        <Stack spacing="5">
          {criterion.requirementGroups.map((g, index) => (
            <EspdRequirementGroupView
              key={g.id}
              group={g}
              espd={espd}
              onChange={onChange}
              readOnly={readOnly}
              parentAnswered={index === 0 || mainAnswerProvided}
            />
          ))}
        </Stack>
      </CardBody>
    </Card>
  );
};
